import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'
import type { ReactNode } from 'react'

import useRebookEvent from '@/legacy-src/components/reservation/hooks/useRebookEvent'
import { dayjs } from '@/legacy-src/lib/dayjs/day'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { ClientBookingAvailableSlotRebookUI } from './ClientBookingAvailableSlotRebook.ui'

export interface ClientBookingAvailableSlotRebookProps {
  slot: FreeSlot
  therapist: TherapistType
  fallback?: ReactNode
}

export const ClientBookingAvailableSlotRebook = ({
  slot,
  therapist,
  fallback,
}: ClientBookingAvailableSlotRebookProps) => {
  const { originalEventData, isRebookingInProgress, rebookEvent } = useRebookEvent()

  if (!isRebookingInProgress) {
    return fallback ?? null
  }

  if (!originalEventData) {
    return null
  }

  const handleRebookEvent = async () => {
    const dateToString = dayjs(slot.startDate).toISOString()
    await rebookEvent({ newStartDate: dateToString, eventId: originalEventData.id })
  }

  return <ClientBookingAvailableSlotRebookUI slot={slot} therapist={therapist} onRebookEvent={handleRebookEvent} />
}
